/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Highlight, connectRefinementList } from "react-instantsearch-dom";

import "./ContestRefinementList.scss";

function RefinementList({
  items,
  isFromSearch,
  refine,
  searchForItems,
  createURL,
  currentRefinement,
}) {
  let specialDealRefinementItem = null;

  items.forEach((item) => {
    if (item.label === "true") {
      specialDealRefinementItem = item;
    }
  });

  return (
    <div className="component-deal-contest-refinement-list tab-headers level-2-headers">
      <a
        href="#"
        className={`tab-header ${
          currentRefinement.includes("true") ? "selected" : ""
        }`}
        onClick={(e) => {
          e.preventDefault();
          refine("true");
        }}
      >
        Special Deals (
        {(specialDealRefinementItem && specialDealRefinementItem.count) || 0})
      </a>
    </div>
  );
}

const SpecialDealsRefinementList = connectRefinementList(RefinementList);

export default SpecialDealsRefinementList;
